module.exports = __webpack_public_path__ + "media/images/trinityfix_background_stage-019d3490.jpg";